export { Sender } from "./Sender";
//# sourceMappingURL=applicationinsights-channel-js.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/applicationinsights-channel-js.js
// module id = ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/applicationinsights-channel-js.js
// module chunks = vendor